import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API, SCAMP_API_RPT } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class RdService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
        this.urlBase = `${SCAMP_API.accountApiV1}/rds`;
    }
    add(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/rds`, data, { headers: this.account.composeHeaders() });
    }
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/rds/${id}`, { headers: this.account.composeHeaders() });
    }
    getByDataAndModeloRD(data, rdModeloId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/rds/by-data-modelrd/${data}/${rdModeloId}`, { headers: this.account.composeHeaders() });
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/rds`, { headers: this.account.composeHeaders() });
    }
    /*   getAllPromise(): Promise<Response> {
    
       return fetch(this.urlBase, {
          method: 'GET',
          headers: this.account.getHearderAuthorization()
        })
    
      } */
    getNextRdNumeroSeq(data) {
        return this.http.get(`${SCAMP_API.accountApiV1}/rds/next-rdnumeroseq/${data}`, { headers: this.account.composeHeaders() });
    }
    getByIntervalAsync(dataInicio, dataTermino) {
        return this.http.get(`${SCAMP_API.accountApiV1}/rds/por-interval/${dataInicio}/${dataTermino}`, { headers: this.account.composeHeaders() });
    }
    getByIntervalPromise(dataInicio, dataTermino) {
        return fetch(`${this.urlBase}/por-interval/${dataInicio}/${dataTermino}`, {
            method: 'GET',
            headers: this.account.getHearderAuthorization()
        });
    }
    imprimirRD(rdId) {
        return this.http.get(`${SCAMP_API_RPT.accountApiV1}/rds/${rdId}`);
    }
    isUniqueDataRdModeloId(data, rdModeloId, id) {
        return this.http.post(`${SCAMP_API.accountApiV1}/rds/is-unique-rddata-rdmodeloid`, { data, fkId: rdModeloId, id }, { headers: this.account.composeHeaders() });
    }
    isUniqueDataRdModeloIdPromise(data, rdModeloId, id) {
        var formdata = new FormData();
        formdata.append("data", data);
        formdata.append("fkId", String(rdModeloId));
        formdata.append("id", String(id));
        return fetch(`${this.urlBase}/is-unique-rddata-rdmodeloid`, {
            method: 'POST',
            headers: this.account.getHearderAuthorization(),
            body: formdata
        });
    }
    getNextRdNumeroSeqPromise(data) {
        return fetch(`${SCAMP_API.accountApiV1}/rds/next-rdnumeroseq/${data}`, {
            method: 'GET',
            headers: {
                "Authorization": this.account.composeHeaders().keys["Authorization"]
            }
        });
    }
}
RdService.ngInjectableDef = i0.defineInjectable({ factory: function RdService_Factory() { return new RdService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: RdService, providedIn: "root" });
